import React, { useContext, useEffect, useState } from 'react';
import AccountForm, { AccountFormFormData } from 'src/components/AccountForm';
import AccountDetailTable from 'src/components/tables/AccountDetailTable';
import ContactsTable from 'src/components/tables/ContactsTable';
import LocationAccessTable from 'src/components/tables/LocationAccessTable';
import AccountLinkUserLoginTable from 'src/components/tables/AccountLinkUserLoginTable';
import HelpDeskUserLoginTable from 'src/components/tables/HelpDeskUserLoginTable';
import LocationsTable from 'src/components/tables/LocationsTable';
import AssetsTable from 'src/components/tables/AssetsTable';
import LicensesTable from 'src/components/tables/LicensesTable';
import ContractsTable from 'src/components/tables/ContractsTable';
import RegistrationTable from 'src/components/tables/RegistrationTable';
import CRMLookupDTO from 'src/models/generated/CRMLookupDTO';
import { AuthenticationContext } from 'src/providers/AuthenticationContext';
import { NotificationUtil } from 'src/utils';
import ApiController from 'src/api/ApiController';
/*import CasesTable from 'src/components/tables/CasesTable';*/

interface CRMLookUPProps {
    loadingTableData: boolean;
    setLoadingTableData: React.Dispatch<React.SetStateAction<boolean>>;
}

const CRMLookUP: React.FC<CRMLookUPProps> = ({ loadingTableData, setLoadingTableData }) => {
    const [tableData, setTableData] = useState<CRMLookupDTO | null>();

    const authContext = useContext(AuthenticationContext);
    const handleSearchAccount = async (formData: AccountFormFormData) => {
        setLoadingTableData(true);

        // Clear out the current data
        setTableData(null);

        // Persist the accountNumber, which is used in the case modal
        await authContext.updateAccountNumber(formData.account);

        try {
            NotificationUtil.close('HomePage');
            const results = await ApiController.getAccountDetails(formData.account);
            setTableData(results.data);
        } catch (error) {
            NotificationUtil.error({
                key: 'HomePage',
                message: 'Error while loading account details',
                error
            });
        }
        setLoadingTableData(false);
    };
    return (
        <div className='crm-lookup-container'>
            <div style={{ marginBottom: '16px' }}>
                <AccountForm onFinish={handleSearchAccount} loading={loadingTableData} />
            </div>

            <AccountDetailTable data={tableData != null ? [tableData] : []} loading={loadingTableData} />
            <ContractsTable data={tableData?.contractList ?? []} loading={loadingTableData} />
            <AssetsTable data={tableData?.assetList ?? []} loading={loadingTableData} />
            <LicensesTable data={tableData?.licenseList ?? []} loading={loadingTableData} />
            <LocationsTable data={tableData?.locationList ?? []} loading={loadingTableData} />
            <ContactsTable data={tableData?.contactList ?? []} loading={loadingTableData} />
            <LocationAccessTable data={tableData?.locationAccessList ?? []} loading={loadingTableData} />
            <AccountLinkUserLoginTable data={tableData?.accountingLinkUserLoginList ?? []} loading={loadingTableData} />
            <HelpDeskUserLoginTable data={tableData?.helpDeskUserLoginList ?? []} loading={loadingTableData} />
            <RegistrationTable data={tableData?.registrationList ?? []} loading={loadingTableData} />
            {/*<CasesTable data={tableData?.caseList ?? []} loading={loadingTableData} />*/}
        </div>
    );
};

export default CRMLookUP;